<template>
  <div>
    <br>
    <Affiliate-Accounts-Card/>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>